const themeContract = {
  argos: {
    badge: {
      background: 'brand-2'
    }
  },
  habitat: {
    badge: {
      background: 'brand-1'
    }
  },
  tu: {
    badge: {
      background: 'brand-1'
    }
  }
}

export { themeContract }
